import { Nav, Navbar, NavLink, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import React, { useState } from 'react';

import riotLogo from '../../images/riot-logo-new.svg'
import aieLogo from '../../images/aie-logo-white.png'
import './navigationBar.css';
import { auth } from '../../firebase-config';

import FishPopup from "../FishPopup";
import Button from '../../components/Shared/Button'
import { useDispatch, useSelector } from "react-redux";
import { setLoggedInUser } from "../Login/redux/actions";

const NavigationBar = ({ loggedIn, setLoggedIn }) => {
  const dispatch = useDispatch();
  const currentUser = useSelector(state => state.user.loggedInUser)

  const [showModal, setShowModal] = useState(false);

  const hideButtonsOnRoutes = ['/login', '/signup', '/resetpassword'];

  const handleLogout = () => {
    auth.signOut();
    dispatch(setLoggedInUser(null));
    localStorage.removeItem('user');
    setLoggedIn(false);
  };

  const handleClose = () => setShowModal(false);

  const location = useLocation();

  if (location.pathname === '/') location.pathname = '/home'

  // if (location.pathname === '/login') {
  //     // hide the navigation bar
  //     return null;
  //   }

  return (
    <div>
      <Navbar className="navbar" collapseOnSelect expand="sm" sticky="top" >
        <Navbar.Toggle aria-controls="navbarScroll" data-bs-toggle="collapse" data-bs-target="#navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Navbar.Brand>
            <img src={riotLogo} style={{ width: 200 }} />
          </Navbar.Brand>
          <Container>
            {!hideButtonsOnRoutes.includes(location.pathname) && (

              <Nav className='contentNav'>
                {/*  <NavLink className="navBarItem" eventKey="1" as={Link} to="/home" active={location.pathname === '/home'}>Home</NavLink>
                    <NavLink className="navBarItem" eventKey="2" as={Link} to="/projects" active={location.pathname === '/projects'}>Projects</NavLink>
                    <NavLink className="navBarItem" eventKey="6" as={Link} to="/pitch" active={location.pathname === '/pitch'}>Pitches</NavLink>*/}
                <NavLink className="navBarItem" eventKey="1" as={Link} to="/home" active={location.pathname === '/home'}>Home</NavLink>
                <NavLink className="navBarItem" eventKey="2" as={Link} to="/projects/ongoing" active={location.pathname === '/projects'}>Projects</NavLink>
                <NavLink className="navBarItem" eventKey="4" as={Link} to="/about" active={location.pathname === '/about'}>About</NavLink>
                {/* {currentUser && <NavLink className="navBarItem" eventKey="4" as={Link} to={`/user/${currentUser.uid}`} active={location.pathname === '/user'}>User</NavLink>} */}
                {currentUser?.level >= 1000 && <NavLink className="navBarItem" eventKey="4" as={Link} to="/admin" active={location.pathname === '/admin'}>Admin</NavLink>}
                {/* <NavLink  eventKey="4" as={Link} to="/team" active={location.pathname === '/team'}>TEAM</NavLink> */}
                {/* <NavLink  eventKey="6" as={Link} to="/pitches" active={location.pathname === '/pitches'}>PIPELINE</NavLink> */}
              </Nav>
            )}

          </Container>

          {/* <Button className="loginButton" eventKey="5" as={Link} to="/signup" active={location.pathname === '/signup'}>Login</Button> */}

          {loggedIn ? (
            <Button buttonStyle='pink large' eventKey='5' text='Logout' onClick={handleLogout} />
          ) : (
            <Button buttonStyle='pink large' text='Login' navigateTo='/login' />
          )}
        </Navbar.Collapse>
      </Navbar>
      <FishPopup
        show={showModal}
        handleClose={handleClose}
      />
    </div>
  );
}

export default NavigationBar;